import React from 'react';
import Logo from '../Assets/Images/New_logo.png'; // Update path to your actual logo file
import { motion } from 'framer-motion';

const UnderDevelopmentPage = () => {
    return (
        <div style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f9fafb",
            padding: "2rem",
            textAlign: "center"
        }}>
            <motion.img
                src={Logo}
                alt="RQM Logo"
                style={{ width: "120px", marginBottom: "1.5rem" }}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
            />

            <motion.h1
                style={{ fontSize: "2.5rem", color: "#333", marginBottom: "1rem" }}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
            >
                🚧 RQM is Under Development 🚧
            </motion.h1>

            <motion.p
                style={{ fontSize: "1.1rem", color: "#666", maxWidth: "600px" }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
            >
                We’re working hard to bring you an amazing experience. Please check back soon or follow us for updates.
            </motion.p>
        </div>
    );
};

export default UnderDevelopmentPage;
